"use client";
import { Navbar, Footer } from "@/components";
import { AboutUs } from "./aboutus";
import { AboutUsDetails } from "./aboutus-details";
import OurGoals from "./our-goals";
import OurTeams from "./our-team";
export default function Campaign() {
  return (
    <>
      <Navbar />
      <AboutUs />
      <AboutUsDetails/>
      <OurGoals/>
      <OurTeams/>
      <Footer />
    </>
  );
}